import { render, staticRenderFns } from "./ProducerSelect.vue?vue&type=template&id=d1da0694&scoped=true"
import script from "./ProducerSelect.vue?vue&type=script&lang=js"
export * from "./ProducerSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1da0694",
  null
  
)

export default component.exports